var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],staticClass:"az"},[_c('div',{staticClass:"AZ"},[_vm._v(_vm._s(_vm.sortFlag ? 'Z - A' : 'A - Z'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }